<template>
  <div
    ref="inviewRef"
    :class="[
      'bg-surface-light border border-surface-grey rounded-md overflow-hidden transition duration-500 delay-400',
      inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4',
    ]"
  >
    <div class="flex">
      <div
        class="w-30 md:w-45 shrink-0 aspect-square border-r border-surface-grey"
      >
        <img
          :src="addon.image"
          :alt="addon.name1"
          class="w-full h-full object-contain md:object-cover"
        />
      </div>
      <div class="grow space-y-4 p-4 md:p-6">
        <div>
          <div class="h4 mb-1">
            {{ addon.name1 }}
          </div>
          <div v-if="addon.description" class="text-text text-sm">
            {{ addon.description }}
          </div>
        </div>

        <div class="flex flex-col md:flex-row justify-between md:items-center">
          <div>
            <div class="flex items-baseline space-x-2 mb-2 md:mb-0">
              <div class="heavy">
                {{ formatPrice(addon.price, addon.currency, $i18n.locale) }}
              </div>

              <div
                v-if="addon.beforePrice"
                class="text-text line-through text-sm"
              >
                {{ $t('common.before') }}
                {{
                  formatPrice(addon.beforePrice, addon.currency, $i18n.locale)
                }}
              </div>
            </div>
          </div>

          <InputCount class="w-34" v-model="count" required />
        </div>
      </div>
    </div>

    <!--BaseSlideTransition>
      <CheckoutCustomFields
        v-if="addon.customFields && addon.customFields.length > 0 && count > 0"
        :ticket-id="ticketId"
        :flex-fields="addon.customFields"
        :count="count"
        type="addon"
      />
    </-BaseSlideTransition -->
  </div>
</template>

<script setup lang="ts">
  import { ref, watch } from 'vue';

  import { useCartStore } from '@/stores/cart';
  import type { Addon } from '@/types';
  import { formatPrice } from '@/utils/formatPrice';
  import { useInView } from '@/utils/useInView';

  //import BaseSlideTransition from '../ui/BaseSlideTransition.vue';
  import InputCount from '../ui/inputs/InputCount.vue';
 // import CheckoutCustomFields from './CheckoutCustomFields.vue';

  const props = defineProps<{
    ticketId: number;
    addon: Addon;
  }>();

  const count = ref(props.addon.count || 0);

  const cart = useCartStore();

  watch(count, newCount => {
    cart.selectAddOns(cart.items[0].id, props.addon.id, newCount);
  });

  const { inviewRef, inView } = useInView();
</script>
